import React from 'react';
import { useTranslation } from 'react-i18next';
import { useContentItems } from '@jwp/ott-hooks-react/src/useContentItems';

import ShelfList from '../../containers/ShelfList/ShelfList';
import { useAutoScroll } from '../../hooks/useAutoScroll';
import Loading from '../Loading/Loading';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

const Home = () => {
  const { data: content, isLoading } = useContentItems();
  const { t } = useTranslation('common');

  useAutoScroll();

  if (isLoading || !content) return <Loading />;

  return (
    <>
      <h1 className="hideUntilFocus">{t('home')}</h1>
      <ShelfList rows={content} />
      <FooterContainer />
    </>
  );
};

export default Home;
